import React from "react";
import propTypes from "prop-types";

import { LinkContainer } from "react-router-bootstrap";
import Nav from "react-bootstrap/cjs/Nav";
import { NavLink } from "react-router-dom";

const NavbarLink = ({ to, children }) => (
  <LinkContainer exact to={to}>
    <Nav.Link exact as={NavLink} to={to}>
      {children}
    </Nav.Link>
  </LinkContainer>
);

NavbarLink.propTypes = {
  to: propTypes.string.isRequired,
};

export default NavbarLink;
